import { render, staticRenderFns } from "./PivotWidget.vue?vue&type=template&id=b0756d02&scoped=true"
import script from "./PivotWidget.vue?vue&type=script&lang=js"
export * from "./PivotWidget.vue?vue&type=script&lang=js"
import style0 from "./PivotWidget.vue?vue&type=style&index=0&id=b0756d02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0756d02",
  null
  
)

export default component.exports